import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Timesheets } from '../models/timesheets';

@Injectable({
  providedIn: 'root'
})

export class TimesheetsService extends CrudService<Timesheets, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/timesheets`);

    this._http = _http;
  }

}

